import React from "react";
import ConfettiExplosion from "react-confetti-explosion";

const ConfettiExplosion1 = () => {
  return (
    <ConfettiExplosion
      width="3500"
      duration="3000"
      particleCount="350"
      zIndex="1"
    />
  );
};

export default ConfettiExplosion1;
